Sensor.create = function (device, type) {
    var sensor = new Sensor();

    sensor.id = Utils.getNextDefaultId(device.sensors, type.plugin, 1);
    sensor.label = Utils.getNextDefaultLabel(device.sensors, type.label, 1);
    sensor.__device = device;
    sensor.__type = type;
    sensor.type = type.plugin;
    sensor.configuration = {};

    for (var n in type.configuration) {
        if (type.configuration[n].defaultValue) {
            sensor.configuration[type.configuration[n].id] = type.configuration[n].defaultValue;
        }
    }

    return sensor;
};

Sensor.bind = function (device, sensor) {
    Utils.inheritMethods(sensor, new Sensor());

    sensor.bind(device);

    return sensor;
};

/**
 *
 */
function Sensor() {
    /**
     *
     */
    Sensor.prototype.bind = function (device) {
        this.__device = device;
        this.__type = device.getSensorType(this.type);

        // Set default values

        for (var n = 0; n < this.__type.configuration.length; ++n) {
            if (!this.configuration[this.__type.configuration[n].id]) {
                this.configuration[this.__type.configuration[n].id] = this.__type.configuration[n].defaultValue;
            }
        }
    };

    /**
     *
     */
    Sensor.prototype.fullId = function () {
        return this.__device.id + "." + this.id;
    };

    /**
     *
     */
    Sensor.prototype.fullLabel = function () {
        return this.__device.label + "." + this.label;
    };
}
